
import { putTags } from '../api/putTags';
import { putUsersCurrency } from '../api/putUserCurrency';
import { setGetTags } from './setGetTags';
import { setGetUserById } from './setGetUserById';

export const setPutUsersCurrency = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await putUsersCurrency(params);
            
            dispatch(setGetUserById(params.user_id));

            alert('Валюта обновлена');
            if (callback) {
                callback()
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}